import React from 'react';
import { useSurvey } from '../../../context/SurveyContext';
import { 
  CircleDot, 
  CheckSquare, 
  ChevronDown, 
  Gauge, 
  Star, 
  Type, 
  AlignLeft, 
  ToggleLeft, 
  Mail, 
  Hash 
} from 'lucide-react';

const questionTypes = [
  { type: 'multipleChoice', label: 'Multiple Choice', icon: CircleDot },
  { type: 'checkboxes', label: 'Checkboxes', icon: CheckSquare },
  { type: 'dropdown', label: 'Dropdown', icon: ChevronDown },
  { type: 'linearScale', label: 'Linear Scale', icon: Gauge },
  { type: 'likertScale', label: 'Likert Scale', icon: Star },
  { type: 'shortAnswer', label: 'Short Answer', icon: Type },
  { type: 'longAnswer', label: 'Long Answer', icon: AlignLeft },
  { type: 'yesNo', label: 'Yes / No', icon: ToggleLeft },
  { type: 'email', label: 'Email', icon: Mail },
  { type: 'number', label: 'Number', icon: Hash }
];

const QuestionTypesSidebar = () => {
  const { addQuestion } = useSurvey();

  return (
    <div className="question-types-sidebar">
      <div className="sidebar-title">Add Question</div>
      {questionTypes.map(({ type, label, icon: Icon }) => (
        <button
          key={type}
          className="question-type-btn"
          onClick={() => addQuestion(type)}
        >
          <Icon size={18} />
          {label}
        </button>
      ))}
    </div>
  );
};

export default QuestionTypesSidebar;
